module.exports = __webpack_public_path__ + "img/tool.c8148520.svg";